export default __webpack_public_path__ + "static/media/logo-light.8038fb7e.svg";